type MenuItemInfoProps = {
    color: string;
    title: string;
    icon: string;
};

export default class MenuItemInfo {
    color: string;

    title: string;

    icon: string;

    constructor({ color, title, icon }: MenuItemInfoProps) {
        this.color = color;
        this.title = title;
        this.icon = icon;
    }
}
